import { Routes, Route, Navigate } from "react-router-dom";
import { TeacherProvider } from "../../context/TeacherContext";
import TeacherLayout from "../../layouts/TeacherLayout";
import TeacherDashboard from "./TeacherDashboard";
import ClassroomDashboard from "./classroom/ClassroomDashboard";
import ClassroomStudentManagement from "./classroom/ClassroomStudentManagement";
import StudentProgress from "./classroom/StudentProgress";
import QuizResults from "./classroom/QuizResults";
import StudentDetail from "./classroom/StudentDetail";
import ClassroomAnalytics from "./classroom/ClassroomAnalytics";
import { ClassroomProvider } from "../../context/ClassroomContext";
import TeacherPreviewRoutes from "./preview";
import ProfilePage from "../shared/ProfilePage";
import GuidePage from "./GuidePage";

const Teacher = () => {
  return (
    <TeacherProvider>
      <ClassroomProvider>
        <TeacherLayout>
          <Routes>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<TeacherDashboard />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="guide" element={<GuidePage />} />
            <Route path="classrooms" element={<ClassroomDashboard />} />
            <Route
              path="classrooms/:classroomId/students"
              element={<ClassroomStudentManagement />}
            />
            <Route
              path="classrooms/:classroomId/progress"
              element={<StudentProgress />}
            />
            <Route
              path="classrooms/:classroomId/quiz-results"
              element={<QuizResults />}
            />
            <Route
              path="classrooms/:classroomId/students/:studentId"
              element={<StudentDetail />}
            />
            <Route
              path="classrooms/:classroomId/analytics"
              element={<ClassroomAnalytics />}
            />
            <Route path="preview/*" element={<TeacherPreviewRoutes />} />
          </Routes>
        </TeacherLayout>
      </ClassroomProvider>
    </TeacherProvider>
  );
};

export default Teacher;
